import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { supabase } from '../../shared/supabase/supabaseClient';
import { buildClientPresencePayload } from './buildClientPresencePayload';
import { shouldReportClientPresence } from './clientPresenceCooldown';

const LAST_REPORT_KEY = '@vuelto/client_presence_last_report_ms';

async function readLastReportMs(): Promise<number | null> {
  if (Platform.OS === 'web' && typeof globalThis.localStorage !== 'undefined') {
    const raw = globalThis.localStorage.getItem(LAST_REPORT_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }
  try {
    const raw = await AsyncStorage.getItem(LAST_REPORT_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

async function writeLastReportMs(ms: number): Promise<void> {
  const value = String(ms);
  if (Platform.OS === 'web' && typeof globalThis.localStorage !== 'undefined') {
    try {
      globalThis.localStorage.setItem(LAST_REPORT_KEY, value);
    } catch {
      // ignore
    }
    return;
  }
  try {
    await AsyncStorage.setItem(LAST_REPORT_KEY, value);
  } catch {
    // ignore
  }
}

/**
 * Best-effort heartbeat de versión/plataforma. Respeta cooldown salvo `force: true`.
 */
export async function reportClientPresenceIfDue(params: {
  organizationId: string;
  userId: string;
  branchId?: string | null;
  force?: boolean;
}): Promise<void> {
  const lastMs = await readLastReportMs();
  if (!params.force && !shouldReportClientPresence(lastMs)) {
    return;
  }

  const payload = await buildClientPresencePayload({
    organizationId: params.organizationId,
    userId: params.userId,
    branchId: params.branchId,
  });

  const { error } = await supabase.rpc('report_client_presence', {
    p_payload: payload,
  });

  if (error) {
    console.warn('[client_presence] report failed', error.message);
    return;
  }

  await writeLastReportMs(Date.now());
}
